import React, { useState } from 'react';
import { TextInput, Textarea, Button, Tabs } from '@mantine/core';

export default function ContentEditor() {
  const [loading, setLoading] = useState(false);

  const handleSave = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-navy">Editor de Conteúdo</h1>
          <p className="text-slate-500">Gerencie os textos e informações dinâmicas do site.</p>
        </div>
        <Button color="orange" loading={loading} onClick={handleSave}>
          Salvar Alterações
        </Button>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <Tabs defaultValue="hero">
          <Tabs.List className="border-b border-slate-200 px-4 pt-4 bg-slate-50">
            <Tabs.Tab value="hero" className="font-medium">Hero Section</Tabs.Tab>
            <Tabs.Tab value="services" className="font-medium">Serviços</Tabs.Tab>
            <Tabs.Tab value="contact" className="font-medium">Contato</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="hero" className="p-6 space-y-6">
            <TextInput
              label="Título Principal (Parte 1)"
              defaultValue="Contabilidade que"
              description="A parte do título que fica na cor branca."
            />
            <TextInput
              label="Título Principal (Parte 2 - Destaque)"
              defaultValue="escala resultados."
              description="A parte do título que recebe o gradiente laranja."
            />
            <Textarea
              label="Subtítulo / Descrição"
              defaultValue="Deixe a burocracia com a JWCosta e foque no crescimento. Oferecemos inteligência financeira, gestão tributária e tecnologia para empresas que pensam grande."
              minRows={3}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <TextInput label="Texto do Botão Primário" defaultValue="Falar com um Especialista" />
              <TextInput label="Texto do Botão Secundário" defaultValue="Conhecer Soluções" />
            </div>
          </Tabs.Panel>

          <Tabs.Panel value="services" className="p-6">
            <p className="text-slate-500 mb-4">Em breve: interface para reordenar e editar os blocos do Bento Grid.</p>
          </Tabs.Panel>

          <Tabs.Panel value="contact" className="p-6 space-y-4">
            <TextInput label="E-mail de Contato" defaultValue="contato@jwcosta.com.br" />
            <TextInput label="Telefone / WhatsApp" defaultValue="(11) 99999-9999" />
            <Textarea label="Endereço Físico" defaultValue="Av. Paulista, 1000 - São Paulo, SP" />
          </Tabs.Panel>
        </Tabs>
      </div>
    </div>
  );
}
